﻿window.cObjetReglementCbInternetMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "Règlement CB internet"; }
    this.mGetAttributBase = function () { return "les " }
    this.mGetNewLib = function () { return "Nouveau règlement CB internet"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') { txt = objet.data.nom }
        else {
            txt = "Règlement CB internet"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "0" }
    this.mGetResume = function () {
        var txt = "";
        return txt;
    }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-credit-card'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();
    }

    //this.contentTemplatePopup = function (contentElement, option) {
    //    contentElement.empty();
    //}

    this.mGetItemTemplateHeight = function (type) {
        return ((type == "Détails") ? 35 : 35)
    }
    this.itemTemplateGrille = function (contentElement, dataTemplate, type, option) {
        var $Table = $("<table style='width:100%;'/>").appendTo(contentElement)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;white-space:nowrap;font-size:130%'/>").appendTo($Tr)
        $Td.html(parseFloat(dataTemplate.mt).formatDisplay() + "€")
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        objet.bddRef.getObjet("doc_cpt", dataTemplate.id_doc_cpt).itemTemplateGrille($Td, null, type, option)
    }

    this.itemTemplateGrillePlus = function (contentElement, dataPlus) {
        $("<span style='' title='Règlement le " + dataPlus.dcr.toFrenchDateTime() + "'><i class='fas fa-hand-holding-dollar dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataPlus.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)
    }

    this.mShowPopup = function (optionPopup) {
        objet.bddRef.getObjet("doc_cpt", objet.data.id_doc_cpt).mShowPopup(optionPopup)
    }
}